import { IconButton } from "@mui/material";
import { AppContext } from "../../../../store/genesys.context";
import React from "react";
import FA__ChevronDown from "../../../../assets/icons/chevron-down-regular-full.svg";
import SvgIcon from "../../icons/svgIcon/svgIcon";

const MinimizeChatBotButton = (): React.JSX.Element => {
  const {
    minimizeBot,
    setMinimizeBot,
  }: {
    minimizeBot: boolean;
    setMinimizeBot: React.Dispatch<React.SetStateAction<boolean>>;
  } = React.useContext(AppContext);

  const handleOnClick = () => {
    localStorage.setItem("minimizeBot", JSON.stringify(!minimizeBot));
    localStorage.setItem("showMinimizeBotPopup", JSON.stringify(false));
    setMinimizeBot(!minimizeBot);
  };

  return (
    <IconButton
      aria-label="Chat minimieren"
      sx={{
        color: (theme) => theme.palette.widgetStyles.navbar.chevronColor,
        "&:hover": {
          backgroundColor: (theme) =>
            theme.palette.widgetStyles.navbar.chevronHoverColor,
          cursor: "pointer",
        },
        // A11Y FIX: visible keyboard focus indicator, matching the other
        // controls. Uses the chevron color so it contrasts on the dark navbar.
        "&:focus-visible": {
          outline: (theme) =>
            `2px solid ${theme.palette.widgetStyles.navbar.chevronColor}`,
          outlineOffset: "2px",
        },
      }}
      onClick={handleOnClick}
    >
      <SvgIcon
        icon={FA__ChevronDown}
        color={(theme) => theme.palette.widgetStyles.navbar.chevronColor}
      />
    </IconButton>
  );
};

export default MinimizeChatBotButton;
